// extracted by mini-css-extract-plugin
export default {"container":"_a473c384"};